import React from 'react';
import { buyerQuestions } from '../data/homepage';
export function QuestionsSection() {
  return <section aria-labelledby="questions-title" className="bg-mist" data-id="element-119" data-mp="2aqr9ebqk9jk3">
      <div className="mx-auto grid max-w-[1280px] gap-8 px-5 py-12 md:px-8 md:py-16 lg:grid-cols-[minmax(0,4fr)_minmax(0,8fr)] lg:gap-20 lg:py-20" data-id="element-120" data-mp="2apg58at7e9sg">
        <h2 id="questions-title" className="text-[30px] font-extrabold leading-[1.12] text-ink md:text-[42px]" data-id="element-121" data-mp="21pjhqcijvgyz">
          Common questions.
        </h2>
        <dl className="border-t border-mist-line" data-id="element-122" data-mp="1s0hz0ekmelhb">
          {buyerQuestions.map(item => <div key={item.q} className="grid gap-2 border-b border-mist-line py-6 md:grid-cols-[minmax(0,5fr)_minmax(0,6fr)] md:gap-10" data-id="element-123" data-mp="1n15alpe3p6cm">
              <dt className="text-[18px] font-bold leading-snug text-ink" data-id="element-124" data-mp="1e0qquugsbzb8">{item.q}</dt>
              <dd className="text-[16px] leading-[1.6] text-ink/80" data-id="element-125" data-mp="1e2thngprhwh0">{item.a}</dd>
            </div>)}
        </dl>
      </div>
    </section>;
}